export default {
    title: "Dodaj proizvod",
    editTitle: "Izmijeni proizvod",
    successEditMessage: "Proizvod je uspješno izmijenjen",
    backLink: 'Nazad na proizvode',
    button: {
        add: "Dodaj proizvod",
        update: "Izmijenite proizvod",
        cancel: "Poništi",
        confirm: "Potvrdi",
    },
    details: {
        title: "Detalji proizvoda",
        productTitle: {
            title: "Naziv",
            placeholder: "Unesite naziv",
        },
        productCategory: {
            title: "Kategorije proizvoda",
            placeholder: "Odaberite kategoriju",
        },
        productSubcategory: {
            title: "Potkategorije proizvoda",
            placeholder: "Odaberite podkategorije",
        },
        productCode: {
            title: "Šifra proizvoda",
            placeholder: "Unesite šifru",
        },
        productDescription: {
            title: "Detalji",
            placeholder: "Unesite detalje",
        },
        productSpecs: {
            title: "Specifikacije (opciono)",
            placeholder: "Unesite specifikacije",
        },

        barcode: {
            title: "Barkod",
            placeholder: "Unesite kod",
        },
        button: "Dodaj još opisa",
    },
    gallery: {
        title: "Galerija",
        idealAspectRatio: 'Idealni aspect ratio je',
        tooltip: "Prva slika u galeriji mora biti jasna slika proizvoda u krupnom planu."
    },
    price: {
        title: "Cijene proizvoda",
        productPrice: {
            title: "Cijena",
        },
        productVAT: "PDV je uračunat u cijenu proizvoda",
        onDiscount: "Da li je proizvod na sniženju?"
    },
    quantity: {
        title: "Količina proizvoda",
        quantity: "Količina u inventaru",
        available: "Dostupno u prodavnici",
        continueSale: "Nastavi sa prodajom nakon isteka zaliha",
    },
    vat: "PDV",
    inBulk: "Prodaje se na mjeru",
    variants: {
        title: "Cijena i količina",
        hasVariants: "Proizvod ima varijante (veličina, boja)",
        delete: "Ukloni",
        weightUnitPlaceholder: "jedinica",
        defaultPrice: "Cijena",
        defaultProductCode: "Kod proizvoda (SKU)",
        overview: {
            title: "Pregled varijanti",
            editOptions: "Izmijeni opcije",
            addVariant: "Dodaj varijantu",
            addNewOption: "Dodaj novu opciju",
            variant: "Varijanta",
            price: "Cijena",
            comparePrice: "Cijena prije sniženja",
            quantity: "Količina",
            sku: "SKU",
            barcode: "Barkod",
            edit: "Izmijeni",
            delete: "Brisanje varijante",
            modalTitle: "Izmijeni varijantu",
            modal: {
                editVariant: {
                    title: 'Izmijeni varijantu'
                },
                addVariant: {
                    title: 'Dodaj varijantu'
                }
            },
            deletedMessage: "Ova varijanta neće biti kreirana",
            undo: "Poništi",
            existsErrorShort: 'Varijanta sa ovom kombinacijom opcija već postoji.',
            existsError: 'Varijanta sa ovom kombinacijom opcija već postoji. Molimo Vas promijenite bar jednu opciju.'
        },
        addOption: {
            title: 'Dodaj novu opciju',
            option: 'Opcija',
            defaultOptionValue: 'Podrazumijevana vrijednost opcije',
            info: "Već postojeće varijante će za novu opciju imati ovu vrijednost",
            buttons: {
                close: 'Zatvori',
                save: 'Sačuvaj'
            }
        },
        option: "Opcija",
        options: "Vrijednosti za opciju",
        button: "Dodaj još jednu varijantu",
        info: "Da bismo kreirali varijante prvo treba da dodamo opcije prema kojima ćemo ih kreirati. " +
            "Npr. ako dodamo opciju Boja i vrijednosti za ovu opciju crvena i crna, a zatim dodamo opciju " +
            "Veličina i vrijednosti S i M dobićemo 4 varijante: crvena S, crvena M, crna S, crna M. " +
            "Ne moramo imati sve varijante za ove opcije, neke možemo i obrisati.",
        optionsInfo: "Ukoliko želite da dodate nove vrijednosti za opcije to možete uraditi u modalu \"Dodaj varijantu\".",
        addOptionValuesInfo: "Ako želite da dodate novu vrijednost za opciju, u select polje te opcije ukucajte naziv i pritisnite enter.",
        cannotBeRemoved: "Varijanta sa ovim vrijednostima opcija je već povezana sa narudžbinom ili korpom, tako da trenutno ne može biti izbrisana.",
        warning: "Upozorenje!"
    },
    deliveries: {
        title: 'Doplata',
        deliversToCities: 'Za neke gradove se plaća doplata.',
        price: 'Cijena',
        municipality: 'Grad',
        button: 'Dodaj još jedan grad'
    },
    delivery: {
        title: "Dostava",
        isPhysical: "Ovo je fizički proizvod",
        description:
            "Kupci neće unositi adresu dostave niti birati način dostave pri kupovini ovog proizvoda.",
        weight: "Težina",
        deliveryDays: 'Okvirni rok isporuke (u danima)'
    },
    searchEngine: {
        title: "Pregled liste pretraživača",
        edit: "Izmijenite SEO website-a",
        pageTitle: {
            title: "Naslov stranice",
            placeholder: "Majica kratkih rukava",
        },
        description: {
            title: "Opis",
            placeholder: "Unesite opis stranice ovdje",
        },
        urlHandle: {
            title: "URL i upravljanje",
            placeholder: "Unesite URL ovdje",
        },
        of: "od",
        slug: 'naziv-proizvoda',
        charactersUsed: "karaktera upotrijebljeno",
        metaTitleInfo: 'Naslov stranice se odnosi na naslov vaše stranice koji je prikazan u isječcima rezultata pretraživača, kao i na kartici stranice u pregledačima.',
        metaDescriptionInfo: 'Opis opisuje i rezimira sadržaj vaše stranice u korist korisnika i pretraživača.'
    },
    activity: {
        title: "Vidljivost",
        status: "Proizvod će biti objavljen.",
        status2: "Proizvod nije objavljen.",
        statusActiveEdit: "Proizvod je objavljen.",
        description:
            "Proizvod možete sačuvati i bez objavljivanja, ali jednom kada ga objavite ne može se više sakriti.",
        planPublishing: "Isplaniraj vrijeme objavljivanja",
        date: {
            title: "Datum",
            placeholder: "Odaberite datum",
        },
    },
    organization: {
        title: "Klasifikacija",
        description: "Ako brend/tag već ne postoji u bazi, ukucajte naziv i imaćete opciju da ga sačuvate.",
        vendor: {
            title: "Brend",
            question:
                "Dodavanje novog proizvođača je preporučljivo samo ako proizvođač već ne postoji u bazi.",
        },
        collection: {
            title: "Kolekcije",
            description:
                "Dodajte proizvod u kolekcije kako bi se lakše pronašao u Vašoj prodavnici.",
        },
        tags: {
            title: "Tagovi",
            question:
                "Dodavanje taga je preporučljivo samo ako tag već ne postoji u bazi.",
        },
    },
};
